import { Icon, Label, TooltipHost, TooltipOverflowMode } from '@fluentui/react';
import React, { ReactNode } from 'react';
import styles from '../../styles/cr.module.scss';

interface ICrLabelProps {
    text?: string;
    required?: boolean;
    icon?: string;
    singleLine?: boolean;
    bold?: boolean;
    children?: ReactNode;
}

export const CrLabel = ({ text, required, icon, singleLine, bold, children }: ICrLabelProps): React.ReactElement =>
    <TooltipHost overflowMode={TooltipOverflowMode.Self} content={text}>
        <Label required={required} className={`${singleLine ? styles.formLabelNoWrap : ''} ${bold ? styles.labelBold : ''}`}>
            <span className={styles.fieldLabelWrapper}>
                {icon &&
                    <Icon iconName={icon} className={styles.fieldLabelIcon} />
                }
                <span>{text || children}</span>
            </span>
        </Label>
    </TooltipHost>;
